import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import BooksIntegrationService from '../../services/BooksIntegrationService';
import {
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
} from "deskera-ui-library";
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
    }
};
export const fetchSyncRevertJEData = createAsyncThunk('syncRevertJEGrid', async () => {
    showLoader()
    const response = await BooksIntegrationService.getPayruns();
    removeLoader()
    return response;
});
export const SyncJEToBooksSlice = createSlice({
    name: 'syncRevertJEGrid',
    initialState,
    reducers: {
        addSyncRevertJEColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToSyncRevertJEColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSyncRevertJEData.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSyncRevertJEData.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addSyncRevertJEColumnConfig, addColumnToSyncRevertJEColumnConfig } =
    SyncJEToBooksSlice.actions;

export const selectPayrunsData = (state) => {
    
    return state.syncRevertJEGrid ? state.syncRevertJEGrid.data : {}
};

export const selectSyncRevertJEColumnConfig = (state) =>
    state.syncRevertJEGrid.columnConfig;

export default SyncJEToBooksSlice.reducer;